import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getClientAPI } from "../service/UserService";
import { updateCommissionAPI } from "../service/AuthService";
import toast from "react-hot-toast";

export default function ClientLimitUpdate() {
  const userData = useSelector((state) => state.account.userData);
  const params = useParams();
  const [search, setSearch] = useState("");
  const [clientData, setClientData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(20);
  const location = useLocation();
  const [userType, setUserType] = useState(params?.userType?.toUpperCase());
  const [id, setId] = useState(location?.state?.userName || "");
  const [updateCommission, setUpdateCommission] = useState({});

  const getClient = async () => {
    const { response } = await getClientAPI(
      search,
      currentPage,
      size,
      id,
      params?.userType.toUpperCase()
    );
    let response_ = response;
    if (response_) {
      response_.childrenUserResponseDTOS = response_.childrenUserResponseDTOSPage.content.sort(
        (a, b) => a.uid - b.uid
      );
      setCurrentPage(response_.childrenUserResponseDTOSPage.number);
      setTotalPages(response_.childrenUserResponseDTOSPage.totalPages);
      setTotalElements(response_.childrenUserResponseDTOSPage.totalElements);
      setSize(response_.childrenUserResponseDTOSPage.size);
    }
    setClientData(response_);
  };
  const handleUpdateCommission = async (type) => {
    let updatedLimit;
    if (type === 'Minus') {
      updatedLimit = -updateCommission.currentLimit;
    } else {
      updatedLimit = updateCommission.currentLimit;
    }
    try {
      const { response, code } = await updateCommissionAPI({ ...updateCommission, currentLimit: updatedLimit });
      if (code === 200) {
        toast.success("Commission Updated Successfully");
        getClient();
        window.location.reload();
        setUpdateCommission({
          ...updateCommission,
          currentLimit: "",
        });
      } else {
        toast.error(response);
      }
    } catch (e) {
      toast.error("Something went wrong");
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    getClient();
  }, [location.state, currentPage]);
  return (
    <>
      <div className="content-wrapper" style={{ minHeight: "1300.41px" }}>
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>{params?.userType?.toLocaleUpperCase()}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/super">{params?.userType?.toLocaleUpperCase()}</a>
                  </li>
                  <li className="breadcrumb-item active">Update {params?.userType?.toLocaleUpperCase()} Limit</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div>
                {/* /.card */}
                <div className="card card-indigo">
                  <div className="card-header">
                    <h4>UPDATE  {params?.userType?.toLocaleUpperCase()}  LIMIT</h4>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    <div
                      id="example1_wrapper"
                      className="dataTables_wrapper dt-bootstrap4 no-footer"
                    >

                      <div className="row">
                        <div className="col-sm-12">
                          <table
                            id="example1"
                            className="table table-bordered table-striped dataTable no-footer"
                            aria-describedby="example1_info"
                          >
                            <thead>
                              <tr>
                                <th

                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="
                                      SNo
                                  : activate to sort column ascending"
                                >
                                  SNo
                                </th>
                                <th

                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Master Name: activate to sort column ascending"
                                >
                                  Master Name
                                </th>
                                <th

                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Limit: activate to sort column ascending"
                                >
                                  Limit
                                </th>
                                <th

                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="Enter Limit: activate to sort column ascending"
                                >
                                  Enter Limit
                                </th>
                                <th

                                  tabIndex={0}
                                  aria-controls="example1"
                                  rowSpan={1}
                                  colSpan={1}
                                  aria-label="My Limit"
                                >
                                  My Limit : {userData?.balance}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientData?.childrenUserResponseDTOS?.map((client, index) => (
                                <tr data-user-id={5363}>
                                  <td>{index + 1}</td>
                                  <td>{client?.username} {client?.name}</td>
                                  <td>
                                    {client?.balance?.toFixed(2)}
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className=" form-control input_full"
                                      min={0}
                                      id="match-commission"
                                      data-field-name="match_commission"
                                      onChange={(e) => {
                                        setUpdateCommission({
                                          ...updateCommission,
                                          id: client?.uid,
                                          currentLimit: e.target.value,
                                        });
                                      }}
                                    />
                                  </td>


                                  <td>
                                    <div className="d-flex" style={{ gap: '5px' }}>
                                      <button onClick={() => handleUpdateCommission('Plus')} class="btn-sm btn-primary" type="submit" name="type" value="Add">
                                        Add
                                      </button>
                                      <button onClick={() => handleUpdateCommission('Minus')} class="btn-sm btn-danger" type="submit" name="type" value="Minus"> Minus
                                      </button>
                                    </div>

                                  </td>
                                  <td>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot></tfoot>
                          </table>
                          <div

                            className="pagination-cls ng-star-inserted"
                          >
                            <pagination-controls

                              previouslabel="Previous"
                              nextlabel="Next"
                              screenreaderpaginationlabel="Pagination"
                              screenreaderpagelabel="page"
                              screenreadercurrentlabel="You're on page"
                            >
                              <pagination-template>
                                <nav role="navigation" aria-label="Pagination">
                                  <ul className="ngx-pagination custom-datatable-pagination">

                                    {/* Previous */}
                                    <li className={`pagination-previous ${currentPage === 0 ? "disabled" : ""}`}>
                                      <span
                                        onClick={() => currentPage > 0 && setCurrentPage(currentPage - 1)}
                                        aria-disabled={currentPage === 0}
                                      >
                                        Previous
                                      </span>
                                    </li>

                                    {/* Current page */}
                                    <li className="current">
                                      <span>
                                        Page {currentPage + 1} of {totalPages}
                                      </span>
                                    </li>

                                    {/* Next */}
                                    <li className={`pagination-next ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                                      <span
                                        onClick={() =>
                                          currentPage < totalPages - 1 && setCurrentPage(currentPage + 1)
                                        }
                                      >
                                        Next
                                      </span>
                                    </li>

                                  </ul>

                                  {/**/}
                                </nav>
                              </pagination-template>
                            </pagination-controls>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
      </div>
      {/*/ END Template Main Content */}
    </>
  );
}
